module.exports = __webpack_public_path__ + "static/media/objects2_17.68fd7c88.svg";